import { getAxiosClient } from "../../axios-client";
import { GenerateOffersRequestBody, GenerateOffersResponse } from "./types";

const axiosClient = getAxiosClient();
export const generateOffers = async (body: GenerateOffersRequestBody) => {
    return await axiosClient.ax.post<GenerateOffersResponse>("/Offers/GenerateOffer", body);
};
